import { media } from "./media";

export type Application = {
  readonly id: string;
  readonly title: string;
  readonly desc: string;
  readonly href: string;
  readonly image: {
    readonly src: string;
    readonly width: number;
    readonly height: number;
    readonly alt: string;
  };
};

export const APPLICATIONS: readonly Application[] = [
  {
    id: "sneaker",
    title: "Design a performance sneaker",
    desc: "Sketch structure, yarn and colorway onto a shoe last.",
    href: "https://spin.variant3d.io/s/share-kPJV88h1",
    image: {
      src: media("Sneaker.webp"),
      width: 315,
      height: 197,
      alt: "A knitted performance sneaker upper in green and black, designed and produced with LOOP.",
    },
  },
  {
    id: "apparel",
    title: "Build custom-fit athletic apparel",
    desc: "Compression, support and stretch mapped to a real body scan.",
    href: "https://spin.variant3d.io/s/share-9R8GQAJR",
    image: {
      src: media("Apparel.webp"),
      width: 315,
      height: 197,
      alt: "Custom-fit leggings built in LOOP, shown as a knit mesh over the body scan.",
    },
  },
  {
    id: "accessories",
    title: "Create knit accessories",
    desc: "Bags, gloves and hats, with knit structures explored in the same design workflow.",
    href: "https://spin.variant3d.io/s/share-BiZDznfd",
    image: {
      src: media("Accessories.webp"),
      width: 315,
      height: 197,
      alt: "A knitted bag in yellow and teal, produced with LOOP.",
    },
  },
  {
    id: "medical",
    title: "Engineer custom-fit medical garments",
    desc: "Compression sleeves and orthopedic wear, built to spec.",
    href: "https://spin.variant3d.io/s/share-uzX2ExDr",
    image: {
      src: media("head_clean_gradient.png"),
      width: 315,
      height: 197,
      alt: "A knitted head form for a custom-fit medical garment, produced with LOOP.",
    },
  },
];
